export default __webpack_public_path__ + "static/Blog-54df582a1c214705f8ed993ceda26798.png";